export default function createInlineEditElement(element, classes) {
  for (const singleClass of classes) {
    element.classList.add(singleClass);
  }

  return element;
}



// WEBPACK FOOTER //
// ./js/utils/addClasses.js